<template>
  <BaseDialog centered contentClass="add-opportunity-status" ref="dialog" :show-actions="true">
    <template slot="title">{{ $t('page.admin-opportunity-management.add-dialog.title') }}</template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div>
          <FormInput
            ref="opportunityNameValue"
            :label="$t('page.admin-opportunity-management.add-dialog.name')"
            is-required
            has-gray-background
            name="name"
            type="name"
            v-model="statusName"
            v-validate="'required'"
          />
          <FormInput
            :label="$t('page.admin-opportunity-management.add-dialog.description')"
            is-required
            has-gray-background
            name="description"
            v-model="statusDescription"
            v-validate="'required'"
          />
          <FormColorPicker
            :label="$t('page.admin-opportunity-management.add-dialog.color')"
            v-model="statusColor"
            is-required
          />
          <div>
            <FormLabel is-required>{{ $t('page.admin-opportunity-management.status-type') }}</FormLabel>
            <BaseSelect
              name="statusType"
              :items="statusTypeOptions"
              item-text="label"
              item-value="value"
              :value="statusType"
              @change="(type) => (statusType = type)"
            />
          </div>
        </div>
        <div class="add-opportunity-status__actions">
          <FormButton is-outlined class="add-opportunity-status__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit" :disabled="isFormInvalid">
            <span>{{ $t('actions.save') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';
import { mapActions, mapGetters } from 'vuex';
import FormColorPicker from '@/components/form/FormColorPicker.vue';
import FormLabel from '@/components/form/FormLabel.vue';
import BaseSelect from '@/components/base/BaseSelect.vue';

export default {
  name: 'AddOpportunityStatusDialog',
  components: {
    BaseSelect,
    FormLabel,
    FormColorPicker,
    BaseDialog,
    FormButton,
    FormInput,
  },
  data() {
    return {
      statusName: '',
      statusDescription: '',
      statusColor: '',
      statusType: '',
    };
  },
  computed: {
    ...mapGetters('opportunityStatuses', ['error']),
    isFormInvalid() {
      return !this.statusName || !this.statusDescription || !this.statusColor || !this.statusType;
    },
    statusTypeOptions() {
      return [
        { label: this.$t('page.admin-opportunity-management.open'), value: 'open' },
        { label: this.$t('page.admin-opportunity-management.closed'), value: 'closed' },
      ];
    },
  },
  methods: {
    ...mapActions('opportunityStatuses', ['addOpportunityStatus']),
    openDialog() {
      this.statusName = '';
      this.statusDescription = '';
      this.statusColor = '#000000';
      this.statusType = '';
      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        const refInput = this.$refs.opportunityNameValue.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      const opportunityStatus = {
        name: this.statusName,
        description: this.statusDescription,
        color: this.statusColor,
        sortingOrder: 2, // 1 is reserved for the reserved open opportunity status
        statusType: this.statusType,
      };
      this.addOpportunityStatus(opportunityStatus)
        .then(() => {
          if (this.error) {
            this.$toast.error(this.error);
            return;
          }
          this.$toast.success(this.$t('page.admin-opportunity-management.add-dialog.add-opportunity-status-success'));
          this.$emit('action-succeeded');
        })
        .catch((error) => this.$toast.error(error));
      this.closeDialog();
    },
    handleKeyup(event) {
      const keyCode = event.keyCode || event.charCode;

      if (keyCode === 13) {
        if (!this.isFormInvalid) this.onSubmit();
        return;
      }
    },
    cancelClick() {
      this.closeDialog();
    },
  },
  created() {
    document.addEventListener('keyup', this.handleKeyup);
  },
  destroyed() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
};
</script>

<style lang="scss">
.base-dialog__add-opportunity-status {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.add-opportunity-status {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
}
</style>
